type BridgeResponseDialogProps = {
  open: boolean;
  title: string;
  subtitle: string;
  loading?: boolean;
  loadingText?: string;
  data: unknown;
  onClose: () => void;
};

/** Mobile-first bridge debug popup (bottom sheet on phone, centered on larger screens). */
const BridgeResponseDialog = ({
  open,
  title,
  subtitle,
  loading = false,
  loadingText = "Waiting for Flutter bridge...",
  data,
  onClose,
}: BridgeResponseDialogProps) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-end justify-center bg-slate-950/50 p-3 backdrop-blur-sm sm:items-center sm:p-4"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="bridge-dialog-title"
    >
      <div
        className="flex w-full max-w-[400px] max-h-[min(85vh,640px)] flex-col overflow-hidden rounded-t-3xl border border-slate-200 bg-white shadow-2xl shadow-slate-950/25 sm:rounded-3xl dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mx-auto mt-2 h-1 w-10 shrink-0 rounded-full bg-slate-300 sm:hidden dark:bg-slate-600" />

        <div className="flex shrink-0 items-start justify-between gap-3 border-b border-slate-100 px-4 pb-3 pt-3 dark:border-slate-800">
          <div className="min-w-0 flex-1 pr-2">
            <p
              id="bridge-dialog-title"
              className="text-base font-semibold leading-tight text-slate-900 dark:text-slate-100"
            >
              {title}
            </p>
            <p className="mt-1 text-xs leading-snug text-slate-500 dark:text-slate-400">
              {loading ? loadingText : subtitle}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="min-h-[44px] shrink-0 rounded-full border border-slate-200 bg-slate-100 px-4 py-2.5 text-sm font-semibold text-slate-700 active:scale-[0.98] dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
          >
            Close
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-3">
          <div className="rounded-2xl bg-slate-50 p-3 text-[11px] leading-6 text-slate-900 sm:text-xs dark:bg-slate-900 dark:text-slate-100">
            {loading ? (
              <p className="text-slate-500">{loadingText}</p>
            ) : (
              <pre className="whitespace-pre-wrap break-all [overflow-wrap:anywhere]">
                {JSON.stringify(data, null, 2)}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BridgeResponseDialog;
